import { render, staticRenderFns } from "./Header2.vue?vue&type=template&id=6122e8b8"
import script from "./Header2.vue?vue&type=script&lang=js"
export * from "./Header2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports